import { css } from 'styled-components';
import {
  getSpacing, SpacingName, BreakpointQueryName, getTypography, TypographyName, ThemedFunctor, rgba,
} from '@doveit/lego';

export const backBar: ThemedFunctor = ({
  theme,
}) => css`
  ${getSpacing.padding(theme, [SpacingName.SMALLEST, 0])}
  border-bottom: 1px solid ${theme.palettes.neutrals.light};
`;

export const secondaryWrapper: ThemedFunctor = ({
  theme,
}) => css`
  position: sticky;
  top: 6.5rem;
  ${getSpacing.paddingBottom(theme, SpacingName.MEDIUM)}
`;

export const minimalToolboxWrapper: ThemedFunctor = ({
  theme,
}) => css`
  ${getSpacing.padding(theme, SpacingName.SMALL)}
  width: 100%;
`;

export const gallery: ThemedFunctor = ({
  theme,
}) => css`
  ${getSpacing.margin(theme, [0, SpacingName.NEGATIVE_SMALL, SpacingName.SMALLER])}
  position: relative;

  &:hover {
    cursor: pointer;
  }

  ${theme.breakpoints.up(BreakpointQueryName.LG)} {
    margin-left: 0;
    margin-right: 0;
  }
`;

export const sold: ThemedFunctor = ({
  theme,
}) => css`
  ${getTypography(theme, TypographyName.H2)}
  text-align: center;
  background-color: ${rgba(theme.palettes.brand.primary, 0.8)};
  position: absolute;
  top: 50%;
  left: 0;
  right: 0;
  padding: 1rem;
  transform: translateY(-50%);
  color: ${theme.palettes.neutrals.lightest};
  text-transform: uppercase;
  z-index: 2;
`;

export const imageCount = css`
  position: absolute;
  right: 1rem;
  bottom: 1rem;
`;

export const requestInfo: ThemedFunctor = ({
  theme,
}) => css`
  ${theme.breakpoints.up(BreakpointQueryName.LG)} {
    display: none;
  }
`;

export const itemAdv: ThemedFunctor = ({
  theme,
}) => css`
  ${getSpacing.padding(theme, [SpacingName.MEDIUM, SpacingName.SMALL, 0])}
  border-top: 1px solid ${theme.palettes.neutrals.light};
  margin: ${theme.spaceUnits.mobile.BIG} -${theme.spaceUnits.mobile.SMALL} -${theme.spaceUnits.mobile.SMALL};

  ${theme.breakpoints.up(BreakpointQueryName.LG)} {
    margin: ${theme.spaceUnits.desktop.BIG} 0 0;
  }
`;

export const carouselWrapper: ThemedFunctor = () => css`
  overflow: hidden;
`;

export const carouselNavigationWrapper: ThemedFunctor = ({ theme }) => css`
  ${getSpacing.marginTop(theme, SpacingName.SMALL)};
`;

export const carouselButtonsWrapper: ThemedFunctor = ({ theme }) => css`
  display: flex;
  align-items: center;
  justify-content: end;

  &::before {
    width: 100%;
    height: 1px;
    background-color: ${theme.palettes.neutrals.light};
    content: "";
    ${getSpacing.marginRight(theme, SpacingName.SMALLER)};
  }
`;
